import _ from 'lodash'
import vm from '~/main'

export default {
  namespaced: true,
  state: {
    recordMediaStream: null,
    mediaRecorder: null,
    mediaRecorderStatus: 'inactive',
    mediaRecorderTimer: 0,
    maxRecordingTime: 30000,
    recordFile: null,
    recordType: null,
  },
  mutations: {
    SET_recordMediaStream(state, payload) {
      console.log('SET_recordMediaStream', payload)
      state.recordMediaStream = payload
    },
    SET_mediaRecorder(state, payload) {
      console.log('SET_mediaRecorder', payload)
      state.mediaRecorder = payload
    },
    SET_mediaRecorderStatus(state, payload) {
      console.log('SET_mediaRecorderStatus', payload)
      state.mediaRecorderStatus = payload
    },
    SET_mediaRecorderTimer(state, payload) {
      state.mediaRecorderTimer = payload
    },
    SET_recordFile(state, payload) {
      state.recordFile = payload
    },
    SET_recordType(state, payload) {
      state.recordType = payload
    },
  },
  getters: {},
  actions: {
    ON_recordMediaStream({ commit, dispatch }, constraints) {
      return new Promise((resolve, reject) => {
        console.log('ON_recordMediaStream')
        if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
          navigator.mediaDevices
            .getUserMedia(constraints)
            .then((stream) => {
              commit('SET_recordMediaStream', stream)
              dispatch('ON_mediaRecorder', constraints)
              resolve(stream)
            })
            .catch((err) => {
              const translateWeb = () => vm.localStorage.translations.pages
              const translateWeb_notifications = translateWeb().common.notifications
              console.log('err', err)
              const errorMessage = (errorName) => {
                switch (errorName) {
                  case 'DevicesNotFoundError':
                  case 'NotFoundError':
                    return translateWeb_notifications['record-devicesnotfounderror']
                  case 'NotAllowedError':
                  case 'PermissionDeniedError':
                    return translateWeb_notifications['record-notallowederror']
                  case 'NotReadableError':
                  case 'TrackStartError':
                    return translateWeb_notifications['record-notreadableerror']
                  case 'OverconstrainedError':
                  case 'ConstraintNotSatisfiedError':
                    // return 'Настройки getUserMedia не могут быть удолетворены'
                    return err.message
                  case 'TypeError':
                    // return 'Пустой объект настроек getUserMedia'
                    return err.message
                  default:
                    return err.message
                }
              }
              dispatch(
                'popup/onMessage',
                {
                  message: err.name + '\n' + errorMessage(err.name),
                  IsError: true,
                  duration: 10000,
                },
                { root: true },
              )
              reject(err)
            })
        } else {
          dispatch(
            'popup/onMessage',
            {
              IsError: true,
            },
            { root: true },
          )
        }
      })
    },
    async ON_mediaRecorder({ state, commit, dispatch }, { audio, video }) {
      console.log('onRecording')
      const type = video ? 'video' : 'audio'
      commit('SET_recordType', type)
      const intervalTick = 300
      const currentRouterStart = { name: vm.$route.name, params: vm.$route.params }
      console.log('currentRouter', currentRouterStart)
      let chunks = []
      let recordingStartTime = null
      const options = {
        // mimeType: 'audio/webm',
      }
      const extension = video ? 'mp4' : 'mp3'
      const fileType = type + '/' + extension
      const stream = state.recordMediaStream
      commit('SET_mediaRecorder', new MediaRecorder(stream, options))
      let recorder = state.mediaRecorder
      const myStream = recorder.stream
      console.log('myStream', myStream)
      recorder.ondataavailable = (e) => {
        // console.log('ondataavailable', e)
        chunks.push(e.data)
        if (state.mediaRecorderStatus !== e.target.state) {
          commit('SET_mediaRecorderStatus', e.target.state)
        }
        if (state.mediaRecorderTimer < state.maxRecordingTime - intervalTick) {
          commit(
            'SET_mediaRecorderTimer',
            Math.abs(new Date(recordingStartTime) - new Date(e.timeStamp)),
          )
        } else {
          if (recorder.state !== 'inactive') {
            recorder.stop()
          }
        }
      }
      recorder.onstart = (e) => {
        console.log('onstart', e)
        commit('SET_mediaRecorderTimer', 0)
        commit('SET_mediaRecorderStatus', e.target.state)
        recordingStartTime = e.timeStamp
      }
      recorder.onstop = (e) => {
        console.log('onstop', e)
        console.log('chunks', chunks)
        const currentRouterEnd = { name: vm.$route.name, params: vm.$route.params }
        if (state.recordMediaStream) {
          state.recordMediaStream.getTracks().forEach((track) => {
            track.stop()
          })
          if (_.isEqual(currentRouterStart, currentRouterEnd)) {
            let blob = new Blob(chunks, { type: fileType })
            const file = new File([blob], 'record.' + extension, { type: fileType })
            commit('SET_recordFile', file)
            console.log('file', file)
          } else {
            dispatch('DELETE_recordFile')
          }
        }
      }
      recorder.start(intervalTick)
    },
    START_record({ state, commit, dispatch }, constraints) {
      dispatch('ON_recordMediaStream', constraints)
    },
    STOP_record({ state, dispatch }) {
      if (state.mediaRecorder) {
        if (state.mediaRecorderStatus === 'recording') {
          state.mediaRecorder.stop()
        } else {
          dispatch('DEFAULT_recordData')
        }
      }
    },
    DELETE_recordFile({ state, commit }) {
      if (state.recordType) {
        commit('SET_recordType', null)
      }
      if (state.recordFile) {
        commit('SET_recordFile', null)
      }
    },
    DEFAULT_recordData({ state, commit, dispatch }) {
      dispatch('DELETE_recordFile')
      if (state.mediaRecorderTimer > 0) {
        commit('SET_mediaRecorderTimer', 0)
      }
    },
  },
}
